import { CustomerPortalLink } from "@convex-dev/polar/react";
import { api } from "convex/_generated/api";
import { useBilling } from "@/packages/features-billing";
import { useTranslation } from "@/packages/utils";

/**
 * Shows a warning banner when the workspace subscription is past due.
 * Renders nothing for active/canceled/no subscriptions.
 */
export function BillingWarningBanner() {
  const { subscription } = useBilling();
  const { t } = useTranslation("common");

  if (!subscription || subscription.status !== "past_due") return null;

  return (
    <div className="bg-destructive/10 border-b border-destructive/20 px-4 py-2 text-sm flex items-center gap-2">
      <span>{t("billing.paymentFailed")}</span>
      <CustomerPortalLink
        polarApi={{
          generateCustomerPortalUrl: api.polar.generateCustomerPortalUrl,
        }}
      >
        <span className="underline font-medium text-destructive hover:text-destructive/80 cursor-pointer">
          {t("billing.updatePaymentMethod")}
        </span>
      </CustomerPortalLink>
    </div>
  );
}
